// extracted by mini-css-extract-plugin
export default {"label":"styles-module--label--iHhZG","timeframe":"styles-module--timeframe--3S_yd"};